const breakpoints = {
    xs: '360px',
    sm: '600px',
    md: '960px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1920px',
    xxxl: '2560px',
};
export { breakpoints };
